import React from 'react'
import { LanguageContext } from '../Language/LanguageContext'
import LifelinkApp from '../asset/image/lifelink-app.jpg'
import AppStore from '../asset/image/download-on-the-app-store-badge.png'
import PlayStore from '../asset/image/google-play-badge.png'
import QRCode from "react-qr-code";
import "./DownloadApp.css"

function DownloadApp() {
    const langCx = React.useContext(LanguageContext)
    const langModal = langCx.lang.download_app

    const qrColor = "#00275e"
    const iosUrl = "https://apps.apple.com/us/app/lifelink/id1540922773"
    const androidUrl = "https://play.google.com/store/apps/details?id=com.lifelinktech.lifelink"
    const lifelinkUrl = "https://www.lifelink.co.th"

    return (
        <div id="download-modal">
            <div className="top-content">
                <div className="app-icon">
                    <img src={LifelinkApp}/>
                </div>
                <div className="download-desc">
                    {langModal.download_desc}
                </div>
                

            </div>
            <div className="content-app">
                <div style={{ marginRight: 30 }}>
                    <QRCode value={iosUrl} size={128} fgColor={qrColor}/>
                    <a href={iosUrl} target="_blank">
                        <img src={AppStore} className="app-badge" style={{ height: 50 }}/>
                    </a>
                </div>
                <div>
                    <QRCode value={androidUrl} size={128} fgColor={qrColor}/>
                    <a href={androidUrl} target="_blank">
                        <img src={PlayStore} className="app-badge" style={{ height: 65, marginTop: 18 }}/>
                    </a>
                </div>
            </div>
            <div className="more-info">
                <div>{langModal.more_information}</div>
                <a href={lifelinkUrl} target="_blank">www.lifelink.co.th</a>
            </div>
        </div>
    )
}

export default DownloadApp
